import React, { useContext } from 'react'

import Button from 'vlm-ui/dist/common/src/components/Button'

import AppContext from '../../../components/App/context'
import PostContext from '../../../components/Post/context'

export const tableIcons = {}

export const tableComponents = {
    PaymentStatus: {
        props: {
            value: 20,
            options: []
        },
        Component: (props) => {
            const { options } = props
            const foundOrderStatusOption = options && options.find(({ value }) => value === props.value)
            const statusText = foundOrderStatusOption?.label

            if (statusText) {
                return (
                    <div>
                        {statusText}
                    </div>
                )
            }

            return null
        }
    },
    RefundButton: {
        props: {
            value: 0,
            label: ''
        },
        Component: ({value, name = 'payment', ...props}) => {

            const appContext = useContext(AppContext)
            const postContext = useContext(PostContext)

            const {post} = postContext

            if (!(value > 0) || !post?._id) {
                return null
            }

            return (
                <div style={{
                    padding: '1px',
                    pointerEvents: 'auto'
                }}>
                    <Button
                        className={props.className}
                        variant={'contained'}
                        label={appContext.labels[name + 'RefundButtonLabel']}
                        href={appContext.routes[name + 'Route'] + '/' + post._id + '/refund'}
                    />
                </div>
            )
        }
    }
}
